import type { ProfileProduct } from '~/types'

export function validForBenefits(profileProduct: ProfileProduct) {
  return profileProduct.benefitsEnabled && !profileProduct.passDeferred
}
